export default "__VITE_PUBLIC_ASSET__03afa820__"